export enum VorlageMessages {
	ASK_DELETE_VORLAGE = 'Möchten Sie diese Vorlage wirklich löschen?',
}
